import Repository from '../Repository';

export default {

	getAssessmentCodes() {
		var response = Repository.get('AssessmentCode/GetAssessmentCodes', {});
		return response;
	},

	getSubjectAssessmentCodes(periodId, qualificationId, assessmentTypeId, subjectId) {
		var response = Repository.get('AssessmentCode/GetSubjectAssessmentCodes', {
			params: {
				periodId: periodId,
				qualificationId: qualificationId,
				assessmentTypeId: assessmentTypeId,
				subjectId: subjectId
			}			
		});
		return response;
	}

}
